module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/salesTools/templates-start-from-template.svg"